import { useProfileSyncing } from "@/hooks/useProfileSyncing";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AnimatePresence, motion } from "framer-motion";
import { Loader2, Check } from "lucide-react";

export default function ProfileSyncIndicator() {
  const { isSyncing, completed, total, error } = useProfileSyncing();
  const [showDone, setShowDone] = useState(false);

  // Show brief "done" state then hide
  useEffect(() => {
    if (!isSyncing && total > 0 && !error) {
      setShowDone(true);
      const t = setTimeout(() => setShowDone(false), 2000);
      return () => clearTimeout(t);
    }
    if (isSyncing) setShowDone(false);
  }, [isSyncing, total, error]);

  // Single error toast
  useEffect(() => {
    if (error) {
      toast.error("Erreur de synchronisation — réessaie ou rafraîchis la page", { duration: 6000 });
    }
  }, [error]);

  const visible = isSyncing || showDone;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.2 }}
          className="fixed bottom-4 right-4 z-50 flex items-center gap-2 rounded-full border border-border/40 bg-background/80 backdrop-blur-md px-4 py-1.5 shadow-lg text-sm"
        >
          {isSyncing ? (
            <>
              <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" />
              <span className="text-muted-foreground">
                Synchronisation… {completed}/{total}
              </span>
            </>
          ) : (
            <>
              <Check className="h-3.5 w-3.5 text-primary" />
              <span className="text-muted-foreground">Profil synchronisé</span>
            </>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
